/* tslint:disable */
/* eslint-disable */
/**
 * Car Repair Register API
 * Evidence of customers and vehicles for small workshops.
 *
 * The version of the OpenAPI document: 1.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Customer } from './Customer';
import {
    CustomerFromJSON,
    CustomerFromJSONTyped,
    CustomerToJSON,
    CustomerToJSONTyped,
} from './Customer';

/**
 * 
 * @export
 * @interface Vehicle
 */
export interface Vehicle {
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    registrationPlate: string;
    /**
     * 
     * @type {Customer}
     * @memberof Vehicle
     */
    customer: Customer;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    vin: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    engineCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    fuelType: string | null;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    enginePower: number | null;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    engineVolume: number | null;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    batteryCapacity: number | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    brand: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    model: string | null;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    yearOfManufacture: number | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    modified: string | null;
}

/**
 * Check if a given object implements the Vehicle interface.
 */
export function instanceOfVehicle(value: object): value is Vehicle {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('registrationPlate' in value) || value['registrationPlate'] === undefined) return false;
    if (!('customer' in value) || value['customer'] === undefined) return false;
    if (!('vin' in value) || value['vin'] === undefined) return false;
    if (!('engineCode' in value) || value['engineCode'] === undefined) return false;
    if (!('fuelType' in value) || value['fuelType'] === undefined) return false;
    if (!('enginePower' in value) || value['enginePower'] === undefined) return false;
    if (!('engineVolume' in value) || value['engineVolume'] === undefined) return false;
    if (!('batteryCapacity' in value) || value['batteryCapacity'] === undefined) return false;
    if (!('brand' in value) || value['brand'] === undefined) return false;
    if (!('model' in value) || value['model'] === undefined) return false;
    if (!('yearOfManufacture' in value) || value['yearOfManufacture'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('modified' in value) || value['modified'] === undefined) return false;
    return true;
}

export function VehicleFromJSON(json: any): Vehicle {
    return VehicleFromJSONTyped(json, false);
}

export function VehicleFromJSONTyped(json: any, ignoreDiscriminator: boolean): Vehicle {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'registrationPlate': json['registrationPlate'],
        'customer': CustomerFromJSON(json['customer']),
        'vin': json['vin'],
        'engineCode': json['engineCode'],
        'fuelType': json['fuelType'],
        'enginePower': json['enginePower'],
        'engineVolume': json['engineVolume'],
        'batteryCapacity': json['batteryCapacity'],
        'brand': json['brand'],
        'model': json['model'],
        'yearOfManufacture': json['yearOfManufacture'],
        'created': json['created'],
        'modified': json['modified'],
    };
}

export function VehicleToJSON(json: any): Vehicle {
    return VehicleToJSONTyped(json, false);
}

export function VehicleToJSONTyped(value?: Vehicle | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'registrationPlate': value['registrationPlate'],
        'customer': CustomerToJSON(value['customer']),
        'vin': value['vin'],
        'engineCode': value['engineCode'],
        'fuelType': value['fuelType'],
        'enginePower': value['enginePower'],
        'engineVolume': value['engineVolume'],
        'batteryCapacity': value['batteryCapacity'],
        'brand': value['brand'],
        'model': value['model'],
        'yearOfManufacture': value['yearOfManufacture'],
        'created': value['created'],
        'modified': value['modified'],
    };
}

